<template>
  <TopNav />
  <SideBar />
   <main class="ml-12 pl-3">
  <div class="row mt-5 pt-5 ms-5">
    <div class="row">
      <div class="col-md-4"></div>
      <div class="col-md-6">
        <h5>İzinlerim</h5>
      </div>
    </div>
   

    <div class="row">
      <div class="col-md-12">
        <table
          id="datatable"
          class="table table-striped table-bordered mt-3 pt-3"
        >
          <thead>
            <tr>
              <th>ID</th>
              
              <th>İzin Tarihi</th>
              <th>Sil</th>
              
          
              
            </tr>
          </thead>
          <tbody>
            <tr
              :class="{ active: index == currentIndex }"
              v-for="(task, index) in this.tasks"
              :key="index"
              @click="clicked(task, index)"
            >
            <td>{{task["id"]}}</td>
            
            <td>{{task["iz_date"]}}</td>
            <td>
              <button class="btn btn-danger" @click="fakeDelete(task['id'])"><i class="bi bi-dash-circle"></i></button>
            </td>
            
           

              
            </tr>
          </tbody>
        </table>
      </div>
    

    
   <div class="card">
      <h5 class="card-title">Yeni Görev</h5>

      <div class="card-body">
        <IzinNew @newAdded="retrieveTasks" />
      </div>
    </div>
    </div>
  </div>
   </main>
</template>

<script>
// @ is an alias to /src
import "jquery/dist/jquery.min.js";
import "datatables.net-dt/js/dataTables.dataTables";
import $ from "jquery";
import { mapState } from "vuex";

import IzinNew from "../components/izin/IzinNew.vue";
import SideBar from "@/components/SideBar";
import TopNav from "@/components/TopNav";
import SelfServices from "../services/SelfServices";



export default {
  name: "Task",
  computed: mapState(["access_token", "api_url"]),
  mounted() {
    const requestParams = {
      method: "GET",
      headers: { Authorization: `Bearer ` + this.access_token },
    };
    fetch(this.api_url+"myizin", requestParams)
      .then((response) => response.json())
      .then((data) => {
        this.tasks = data;
        console.log(this.tasks);
        setTimeout(() => {
          $("#datatable").DataTable({
            language: {
              url: "https://cdn.datatables.net/plug-ins/1.10.20/i18n/Turkish.json",
            },
            lengthMenu: [
              [10, 25, 50, -1],
              [10, 25, 50, "Hepsi"],
            ],
            pageLength: 10,
          });
        });
      });
  },
  data: function () {
    return {
      tasks: [],
      currentIndex: -1,
      currentTask: null,
      showIt: false,
    };
  },
  components: {
    IzinNew,
    TopNav,
    SideBar
  },
  methods: {
    clicked(task, index) {
      console.log(task.name);
      this.currentTask = task;
      this.currentIndex = task ? index : -1;
      this.showIt = true;
    },
    fakeDelete(id){
      SelfServices.deleteizin(id)
      setTimeout(function() {
  //your code to be executed after 1 second
}, 1000);
      this.retrieveTasks()
      this.retrieveTasks()
    },
    retrieveTasks() {
      const requestParams = {
        method: "GET",
        headers: { Authorization: `Bearer ` + this.access_token },
      };
      fetch(this.api_url+"myizin", requestParams)
        .then((response) => response.json())
        .then((data) => {
          this.tasks = data;
          console.log(this.tasks);
        });
    },
  },
};
</script>
<style scoped>
@import "~datatables.net-dt/css/jquery.dataTables.min.css";
.active {
  background-color: azure !important;
}
th {
  background-color: lightblue;
  border-radius: 5px !important;
}
</style>